export enum BankTypeEnum {
  MIT = 'MIT',
  CARD = 'TARJETA',
  OPENPAY = 'OPENPAY',
  PAYPAL = 'PAYPAL',
  PLUGNPAY = 'PLUGNPAY',
  FRON_DESK = 'FRONT-DESK',
  MERCADOPAGO = 'MERCADOPAGO',
}
